export const TokenFlagInStorage = 'LOGIN_USER_TOKEN_INFO'

export const Region = [
  {
    name: '马来西亚',
    children: [
      {
        name: '玻璃市',
      },
      {
        name: '吉打',
      },
      {
        name: '槟城',
      },
      {
        name: '霹雳',
      },
      {
        name: '雪兰莪',
      },
      {
        name: '森美兰',
      },
      {
        name: '马六甲',
      },
      {
        name: '柔佛',
      },
      {
        name: '彭亨',
      },
      {
        name: '登嘉楼',
      },
      {
        name: '吉兰丹',
      },
      {
        name: '砂拉越',
      },
      {
        name: '沙巴',
      },
      {
        name: '吉隆坡',
      },
      {
        name: '纳闽',
      },
      {
        name: '布城',
      }
    ],
  },
  {
    name: '印度尼西亚',
    children: [],
  },
  {
    name: '菲律宾',
    children: [],
  },
  {
    name: '新加坡',
    children: [],
  },
  {
    name: '泰国',
    children: [],
  },
  {
    name: '越南',
    children: [],
  },
  {
    name: '缅甸',
    children: [],
  },
  {
    name: '东帝汶',
    children: [],
  },
  {
    name: '文莱',
    children: [],
  },
  {
    name: '柬埔寨',
    children: [],
  },
  {
    name: '老挝',
    children: [],
  }
]